import styled from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        gap: 24px;
        background-color: ${({ theme }) => theme.color["white"]};
        border-radius: 20px;
    `,
    "TitleDiv": styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;

        h2 {
            ${({ theme }) => theme.font["large-semibold"]};
        }

        button {
            width: 12px;
            height: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    `,

    "AgreeList": styled.div`
        height: 440px;
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
    "AgreeElement": styled.div`
        height: ${({ $size }) => $size && 100 / $size}%;
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
    "AgreeCheckButton": styled.button`
        display: flex;
        align-items: center;
        gap: 8px;
    
        & > img {
            width: 16px;
        }

        & > h2 {
            ${({ theme }) => theme.font["small-medium"]};
            text-align: left;
        }
    `,
    "Exception": styled.p`
        ${({ theme }) => theme.font["small-medium"]};
        color: ${({ theme }) => theme.color["error"]};
    `,
    "AgreeContent": styled.p`
        height: 100%;
        overflow-y: scroll;
        border-radius: 4px;
        border: 1px solid ${({ theme }) => theme.color["grey2"]};
        padding: 12px;
        ${({ theme }) => theme.font["small-regular"]};
    `
}